var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"loading"},[_c('span',{staticStyle:{"animation-delay":"0.6s"}},[_vm._v(".")]),_c('span',{staticStyle:{"animation-delay":"0.4s"}},[_vm._v(".")]),_c('span',{staticStyle:{"animation-delay":"0.2s"}},[_vm._v(".")])])
}]

export { render, staticRenderFns }